export const blacklist = {
  blacklistedUsers: "Blacklisted Users",
  type: "Type",
  value: "Value",
  reason: "Reason",
  createdBy: "Created By",
  createdAt: "Created Date",
  createBlacklistUser: "Created Blacklist User",
  unlock: "Unlock",
  reset: "Reset",
  delete: "Delete",
  close: "Close",
  submit: "Submit",
  advanceFilter: "Advance Filter",
  createByCMS: '"Create By CMS" filter',
};
